/**
 * @generated SignedSource<<24ba6dc08c8825f8d0a7efacd65a92d0>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type GetHelpZendeskCommonQuestions_viewer$data = {
  readonly getHelpCmsTopics: ReadonlyArray<{
    readonly groupLabel: string | null;
    readonly topics: ReadonlyArray<{
      readonly topicKey: string | null;
      readonly topicLabel: string | null;
    } | null> | null;
  } | null> | null;
  readonly " $fragmentType": "GetHelpZendeskCommonQuestions_viewer";
};
export type GetHelpZendeskCommonQuestions_viewer$key = {
  readonly " $data"?: GetHelpZendeskCommonQuestions_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"GetHelpZendeskCommonQuestions_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "GetHelpZendeskCommonQuestions_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "getHelpCmsTopicGroup",
      "kind": "LinkedField",
      "name": "getHelpCmsTopics",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "groupLabel",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "getHelpCmsTopicGroupTopic",
          "kind": "LinkedField",
          "name": "topics",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "topicKey",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "topicLabel",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "35690a072de3569ecb89cb23cc907c29";

export default node;
